import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { RisorseAndRisorseTipologie } from "../prismaTypes";
import { TabellaTariffe } from "./TabellaTariffe";
import { memo } from "react";

export const SettimanaRisorsa = memo(function SettimanaRisorsa(props: {
  risorsa: RisorseAndRisorseTipologie;
  giorni: Date[];
  modPrenota: boolean;
  isAuthenticated: boolean;
  settimana: boolean;
}) {
  const { risorsa, giorni, modPrenota } = props;

  if (giorni === undefined) return <></>;

  return (
    <div>
      <Title denominazione={risorsa.denominazione} />

      <Stack direction={{ xs: "column", sm: "column", md: "row" }}>
        {giorni.length > 0 && (
          <TabellaTariffe risorsa={risorsa} giorni={giorni} modPrenota={modPrenota} />
        )}
      </Stack>
    </div>
  );
});

const Title = memo(function Title(props: { denominazione: string | null }) {
  const { denominazione } = props;
  return <Typography variant="h5">{denominazione}</Typography>;
});
